import React, { Component, Fragment } from "react";
import Slider from 'react-slick';
import { Translation, withTranslation } from 'react-i18next';
import { connect } from 'react-redux';
import { mapStateToProps } from '../redux/selector/selector';
import { withRouter } from 'react-router-dom';
import { LazyLoadImage } from 'react-lazy-load-image-component';
import MessagePopUp from "./MessagePopUp";
import FormPopUp from "./FormPopUp";

function SampleNextArrow(props) {
  const { style, onClick } = props;
  return (
    <div className='slick-next-btn' style={{ ...style }} onClick={onClick}>
      <i className="icon-arrow-big right"></i>
    </div>
  );
}
function SamplePrevArrow(props) {
  const { style, onClick } = props;
  return (
    <div className='slick-prev-btn' style={{ ...style }} onClick={onClick}>
      <i className="icon-arrow-big left"></i>
    </div>
  );
}

class Promotions extends Component {
  isMount = true;
  constructor(props) {
    super (props);
    this.state = {
      promotionList: [],
      activeTab: 'ALL',
      detailModal: false,
      formModal: false,
      loginModal: false,
      msgTitle: '',
      msgContent: '',
      applyContent: [],
      monthlyList: []
    };
    this.toggle = this.toggle.bind(this);
    this.toggleDetailModal = this.toggleDetailModal.bind(this);
    this.toggleFormModal = this.toggleFormModal.bind(this);
  }

  toggleDetailModal = (info) => {
    this.setState({ detailModal: !this.state.detailModal, loginModal: false });
    this.setState({ msgTitle: info.title })
    window.SPL_Content.loadPromotionContent(info.content).then((data) => {
      this.setState({ msgContent: data.content })
    });
  }

  toggleFormModal = (info) => {
    const { isLogin } = this.props.user;
    if (!isLogin) {
      this.setState({ detailModal: true, loginModal: true }, () => {
        this.loginMsg();
      });
    } else {
      if (info.applyAction === 'REDIRECT') {
        this.props.history.push('/myaccount/transfer');
      } else if (info.applyAction === 'FORM') {
        this.setState({ formModal: !this.state.formModal, loginModal: false });
        this.setState({ applyContent: info });
      } else {
        this.setState({ formModal: false, loginModal: false });
        this.setState({ applyContent: info });
      }
    }
  }

  loginMsg = () => {
    if (this.state.loginModal) {
      this.setState({ msgTitle: 'login:login.proceed' })
    }
  }

  onTabClick(index) {
    let promotionTypes = this.state.promotionList.promotionTypes;
    let promotionType = promotionTypes[index].promotionType;
    this.getPromotionContent(promotionType);
    this.setState({ activeTab: promotionType });
  }

  handleTabClick = (event) => {
    this.setState({ activeTab: event.target.id });
  };

  componentDidMount() {
    this.isMount = true;
    this.getPromotionContent('all');
  }

  componentDidUpdate(prevProps) {
    if (prevProps.screen.isMobile !== this.props.screen.isMobile) {
      this.getPromotionContent('all');
    }
    if (this.state.filterMsgTitle !== '' || this.state.filterMsgContent !== '') {
      this.setState({ filterMsgTitle: '', filterMsgContent: '' })
    }
  }

  getPromotionContent = () => {
    const { language, screen } = this.props;

    window.SPL_Content.getMonthlyPromo(language.countryLanguageKey, screen.viewType).then((data) => {
      if (this.props.portal.settings && this.props.portal.settings.monthlyPromoGetFromPromo === true) {
        this.setState({ monthlyList: data.monthlyList });
      } else {
        this.setState({ monthlyList: data });
      }
    });
  }

  componentWillUnmount() {
    this.isMount = false;
  }

  toggle(tab) {
    this.onTabClick(tab);
    this.setState({
      activeTab: tab,
    });
  }

  openPromoPage = () => {
    if (this.props.portal.settings.monthlyPromoGetFromPromo === false) {
      this.props.history.push('/promotion');
    }
  }

  render() {
    const { monthlyList } = this.state;
    const { settings } = this.props.portal;

    var promoSlide = {
      infinite: true,
      slidesToShow: 3,
      slidesToScroll: 1,
      swipeToSlide: true,
      dots: true,
      autoplay: false,
      autoplaySpeed: 1500,
      pauseOnHover: true,
      nextArrow: <SampleNextArrow />,
      prevArrow: <SamplePrevArrow />,
      responsive: [
        {
          breakpoint: 768,
          settings: {
            swipeToSlide: false
          }
        }
      ]
    };

    const {
      msgTitle,
      msgContent,
      detailModal,
      loginModal,
      applyContent,
    } = this.state;

    let modalMsg = {
      msgTitle: msgTitle,
      msgContent: msgContent,
      detailModal: detailModal,
      loginModal: loginModal,
      applyContent: applyContent,
      toggleDetailModal: this.toggleDetailModal,
      toggleFormModal: this.toggleFormModal,
    }

    return (
      <Translation>
        {(t) => (
          <div>
            {this.state.detailModal &&
              <MessagePopUp modalMsg={modalMsg} />
            }
            {this.state.formModal &&
              <FormPopUp modalMsg={modalMsg} />
            }

            <div className="content-top">
              <span className="content-title">{t('home:home.monthlyPromo', 'This Month Promotions')}</span>
              <span className="more-info" style={{ display: 'none' }} onClick={this.openPromoPage}>
                {t('promotion:promotion.button', 'more info')}
              </span>
            </div>
            <div className="content-center-box">
              <div className="content-center bg-black">
                {!this.props.screen.isMobile && monthlyList && monthlyList.length >= 3 ? (
                  <Slider {...promoSlide}>
                    {(monthlyList || []).map((content, contentIndex) => {
                      return (
                        <ul key={content.id}>
                          <li onClick={this.openPromoPage}>
                            <div className="img-box">
                              <LazyLoadImage src={content.monthlyImage_webp || content.monthlyImage} alt='promotion' width="100%" height="100%" style={{ objectFit: 'contain' }} />
                            </div>
                            <div className='promoBox-content'>
                              <p className='promoBox-title'>{content.title}</p>
                              <p className='promoBox-text' dangerouslySetInnerHTML={{ __html: content.description && content.description }}></p>
                            </div>
                            <div className='promoBox-btn'>
                              {settings && settings.monthlyPromoGetFromPromo === true ?
                                <Fragment>
                                  <div className='btn-promo-details' onClick={() => this.toggleDetailModal(content)}>
                                    <span>{t('promotion:promotion.detail')}</span>
                                  </div>
                                  <div className={`btn-promo-apply ${content.isAllowApply ? 'apply-show' : 'apply-hide'} `}
                                    onClick={() => this.toggleFormModal(content)}>
                                    <span>{t('promotion:promotion.apply')}</span>
                                  </div>
                                </Fragment>
                              :
                                <div className='btn-promo-details' onClick={this.openPromoPage}>
                                  <span>{t('promotion:promotion.moreDetail', 'More Detail')}</span>
                                </div>
                              }
                            </div>
                          </li>
                        </ul>
                      );
                    })}
                  </Slider>
                ) : monthlyList && monthlyList.length > 0 && monthlyList.length < 3 || this.props.screen.isMobile && monthlyList && monthlyList.length > 0 ? (
                  <div className='promoBox'>
                    {(monthlyList || []).map((content, contentIndex) => {
                      return (
                        <ul key={content.id}>
                          <li onClick={this.openPromoPage}>
                            <div className="img-box">
                              <LazyLoadImage src={content.monthlyImage_webp || content.monthlyImage} alt='promotion' width="100%" height="100%" style={{  objectFit: 'contain' }} />
                            </div>
                            <div className='promoBox-content'>
                              <p className='promoBox-title'>{content.title}</p>
                              <p className='promoBox-text' dangerouslySetInnerHTML={{ __html: content.description && content.description }} ></p>
                            </div>
                            <div className='promoBox-btn'>
                              {settings && settings.monthlyPromoGetFromPromo === true ?
                                <Fragment>
                                  <div className='btn-promo-details' onClick={() => this.toggleDetailModal(content)}>
                                    <span>{t('promotion:promotion.detail')}</span>
                                  </div>
                                  <div className={`btn-promo-apply ${content.isAllowApply ? 'apply-show' : 'apply-hide'} `}
                                    onClick={() => this.toggleFormModal(content)}>
                                    <span>{t('promotion:promotion.apply')}</span>
                                  </div>
                                </Fragment>
                              :
                                <div className='btn-promo-details' onClick={this.openPromoPage}>
                                  <span>More Detail</span>
                                </div>
                              }
                            </div>
                          </li>
                        </ul>
                      );
                    })}
                  </div>
                ) : (
                  <div className='no-Data'>{t('promotion:promotion.no-promo', 'No Promotion')}</div>
                )}
              </div>
            </div>
          </div>
        )}
      </Translation>
    );
  }
}

export default connect(mapStateToProps)(withTranslation()(withRouter(Promotions)));